import { useEffect, useRef } from 'react';
import { Play, Pencil, Trash2, CircleDot, Circle, CircleX } from 'lucide-react';

export function CanvasContextMenu({ menu, onAction, onClose }) {
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('mousedown', handleClick);
    window.addEventListener('keydown', handleKey);
    return () => {
      window.removeEventListener('mousedown', handleClick);
      window.removeEventListener('keydown', handleKey);
    };
  }, [onClose]);

  if (!menu) return null;

  const items = menu.type === 'state' ? menu.items : menu.items;

  return (
    <div
      ref={ref}
      className="absolute z-50 min-w-[160px] rounded-md border bg-popover p-1 text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95"
      style={{ left: menu.screenX, top: menu.screenY }}
      data-testid="canvas-context-menu"
    >
      {items.map((item, i) => {
        if (item.separator) {
          return <div key={i} className="-mx-1 my-1 h-px bg-border" />;
        }
        const Icon = item.icon;
        return (
          <button
            key={item.action}
            className="relative flex w-full cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none hover:bg-accent hover:text-accent-foreground"
            onClick={() => { onAction(item.action, menu.id); onClose(); }}
            data-testid={`ctx-${item.action}`}
          >
            {Icon && <Icon className="w-3.5 h-3.5 mr-2 shrink-0" />}
            <span>{item.label}</span>
            {item.checked && <span className="ml-auto text-xs text-primary">●</span>}
          </button>
        );
      })}
    </div>
  );
}

export function buildStateMenuItems(state, isTM) {
  const items = [
    { action: 'rename', label: 'Rename', icon: Pencil },
    { separator: true },
    { action: 'set-initial', label: 'Set as Initial', icon: Play, checked: state.is_initial },
    { action: 'toggle-final', label: isTM ? 'Toggle Accept' : 'Toggle Final', icon: CircleDot, checked: state.is_final },
  ];
  if (isTM) {
    items.push({ action: 'toggle-reject', label: 'Toggle Reject', icon: CircleX, checked: state.is_reject });
  }
  items.push({ separator: true });
  items.push({ action: 'delete', label: 'Delete', icon: Trash2 });
  return items;
}

export function buildTransitionMenuItems(isPDA, isTM) {
  return [
    { action: 'edit', label: (isPDA || isTM) ? 'Edit Rules' : 'Edit Label', icon: Pencil },
    { separator: true },
    { action: 'delete', label: 'Delete', icon: Trash2 },
  ];
}
